var symphony = symphony || {};

;(function() {

  symphony.alertsDisplay = function() {

  	if(localStorage.getItem(siteId)){
  		return;
  	}

  	if(!_.isUndefined(symphony) && !_.isUndefined(symphony.admin) && !_.isUndefined(symphony.admin.activeConductorDocs)){
  		var activeProperties = [];
		var today = moment().utc()._d;

		activeProperties = {
			objects:symphony.admin.activeConductorDocs
		}

		var index = _.findIndex(activeProperties.objects, function(property) {  return property.name === "alerts" });

		if (activeProperties.objects[index] && activeProperties.objects[index] != null) {
			var propertyObject = JSON.parse(activeProperties.objects[index].value);

			activeProperties.objects[index].value = propertyObject;

			_(activeProperties.objects[index].value.objects).forEach(function(prop){
				if(_.findIndex(prop.activeSites, function(id){ return id === siteId }) !== -1){
					if(moment(moment(prop.endDate, "MM-DD-YYYY").utc()._d).isAfter(today) && moment(moment(prop.startDate, "MM-DD-YYYY").utc()._d).isBefore(today)) {

						if(!(localStorage.getItem(siteId) && localStorage.getItem(siteId) == prop.title)) {
							localStorage.setItem(siteId, prop.title);
							$('.givingToolbar-toolbar').addClass('hasAlert');
							$('.globalHeader').append('<div class="alert" style="background-color:#ed1c2b;background-color:' + prop.bgColor + '">' + prop.message + '</div>');
						}

						
					}
				}
			});

			$('.adminNotification-close').on('click', function(){
				var name = _.camelCase($(this).parent().data('title'));
				$(this).parent().remove();
				localStorage.setItem(name, 'closed');
			});
		}

  	} else {
  		$.get('/' + territory.toLowerCase() + '_conductor/json/properties?random=' + (new Date().getUTCMilliseconds()),
			function(data){
				var activeProperties = [];
				var today = moment().utc()._d;

				activeProperties = JSON.parse(data);

				var index = _.findIndex(activeProperties.objects, function(property) {  return property.name === "alerts" });

				if (activeProperties.objects[index] && activeProperties.objects[index] != null) {
					var propertyObject = JSON.parse(activeProperties.objects[index].value);

					activeProperties.objects[index].value = propertyObject;

					_(activeProperties.objects[index].value.objects).forEach(function(prop){
						if(_.findIndex(prop.activeSites, function(id){ return id === siteId }) !== -1){
							if(moment(moment(prop.endDate, "MM-DD-YYYY").utc()._d).isAfter(today) && moment(moment(prop.startDate, "MM-DD-YYYY").utc()._d).isBefore(today)) {

								if(!(localStorage.getItem(siteId) && localStorage.getItem(siteId) == prop.title)) {
									localStorage.setItem(siteId, prop.title);
									$('.givingToolbar-toolbar').addClass('hasAlert');
									$('.globalHeader').append('<div class="alert" style="background-color:#ed1c2b;background-color:' + prop.bgColor + '">' + prop.message + '</div>');
								}

								
							}
						}
					});

					$('.adminNotification-close').on('click', function(){
						var name = _.camelCase($(this).parent().data('title'));
						$(this).parent().remove();
						localStorage.setItem(name, 'closed');
					});
				}
			}
		);
  	}
	

  };


})();